import { render, staticRenderFns } from "./LogHeartRate.vue?vue&type=template&id=2af7c618&scoped=true&lang=pug&"
import script from "./LogHeartRate.vue?vue&type=script&lang=js&"
export * from "./LogHeartRate.vue?vue&type=script&lang=js&"
import style0 from "./LogHeartRate.vue?vue&type=style&index=0&id=2af7c618&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af7c618",
  null
  
)

export default component.exports